/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OktaIdentityProviderConnection,
  OktaIdentityProviderConnection$inboundSchema,
} from "./oktaidentityproviderconnection.js";

/**
 * The organization's Okta connection, or nothing when none is connected.
 */
export type GetIdentityProviderConnectionResult = {
  /**
   * An organization's Okta connection: the service application Speakeasy authenticates to the Okta Management API with, its verification state, and the console checklist. Never carries key material or tokens.
   */
  connection?: OktaIdentityProviderConnection | undefined;
};

/** @internal */
export const GetIdentityProviderConnectionResult$inboundSchema: z.ZodMiniType<
  GetIdentityProviderConnectionResult,
  unknown
> = z.object({
  connection: z.optional(OktaIdentityProviderConnection$inboundSchema),
});

export function getIdentityProviderConnectionResultFromJSON(
  jsonString: string,
): SafeParseResult<GetIdentityProviderConnectionResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetIdentityProviderConnectionResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetIdentityProviderConnectionResult' from JSON`,
  );
}
